import { POLL_BACKOFF_MAX_MS, POLL_INTERVAL_MS, POLL_JITTER_MAX_MS } from '../config.js';

/**
 * Exponential backoff with cap and jitter (ms until next retry).
 * @param {number} currentMs
 */
export function nextBackoffMs(currentMs = POLL_INTERVAL_MS) {
  const doubled = Math.min(currentMs * 2, POLL_BACKOFF_MAX_MS);
  const jitter = Math.floor(Math.random() * POLL_JITTER_MAX_MS);
  return doubled + jitter;
}

export function resetBackoffMs() {
  return POLL_INTERVAL_MS;
}
